<template>
    <div>
        <div class="view-type" style="margin-top: 20px">
            <iu-radio-group v-model="viewTypeStr" size="small" @change="onViewType">
                <iu-radio-button label="daily">Daily</iu-radio-button>
                <iu-radio-button label="weekly">Weekly</iu-radio-button>
                <iu-radio-button label="monthly" disabled>Monthly</iu-radio-button>
            </iu-radio-group>
        </div>
        <vc-calendar class="vc-calendar" @dayclick="handleDayClick" :attributes="calendarAttributes" />
        <div class="category-wrapper">
            <div class="category-title-wrapper">
                <span class="category-header">CHANNELS</span>
                <iu-button class="category-add" type="text" @click="openAddCategory">
                    <i class="fa fa-plus"></i>
                </iu-button>
            </div>
            <ul>
                <li :class="[isSelected('') ? 'selected' : '']">
                    <iu-button class="category-title" type="text" @click="onClickTitle('')"># General</iu-button>
                </li>
                <li
                    v-for="(category, index) in categories"
                    :key="category.id"
                    :class="[isSelected(category.id) ? 'selected' : '']"
                >
                    <iu-button
                        type="text"
                        class="category-title"
                        @click="onClickTitle(category.id)"
                        v-bind:style="{ color: colors[index] }"
                        ># {{ category.title }}</iu-button
                    >
                    <iu-button class="category-option" type="text" @click="openUpdateCategoryName(category.id)">
                        <i class="fa fa-pencil"></i>
                    </iu-button>
                    <iu-button class="category-option" type="text" @click="handleDeleteCategory(category.id)">
                        <i class="fa fa-times"></i>
                    </iu-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import utils from '@/utils';
import { colorArray } from '@/constans/color';

export default {
    data: function() {
        return {
            willRemoveFocusedTask: false,
            viewTypeStr: this.viewType,
            colors: colorArray,
        };
    },
    computed: {
        calendarAttributes() {
            let selectedDates = {
                key: 'selected',
                highlight: true,
                order: 0,
            };

            if (this.viewType === 'daily') {
                selectedDates.dates = utils.date.parseFormatToDate(this.selectedDate).toDate();
            } else if (this.viewType === 'weekly') {
                const dateRange = utils.date.getWeeklyDateRange(utils.date.parseFormatToDate(this.selectedDate));

                selectedDates.dates = {
                    start: dateRange.startDate.toDate(),
                    end: dateRange.endDate.toDate(),
                };
            }

            return [
                {
                    key: 'today',
                    highlight: {
                        color: 'blue',
                        fillMode: 'light',
                        class: 'vc-calendar-key-today',
                    },
                    dates: new Date(),
                    order: 10,
                },
                selectedDates,
            ];
        },
    },
    watch: {
        viewType: function() {
            this.viewTypeStr = this.viewType;
        },
    },
    methods: {
        handleDayClick(day) {
            this.onConfirmDate(day.id);
        },
        openAddCategory() {
            this.$prompt('Please input your category name', 'Add category', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputPattern: /^(?=[\S\s]{1,20}$)[\S\s]*/,
                inputErrorMessage: 'This category name is too long!',
            })
                .then(result => {
                    this.$message({
                        type: 'success',
                        message: 'Your new category is added',
                    });

                    this.onAddCategory(result.value);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Canceled to add new category',
                    });
                });
        },
        openUpdateCategoryName(id) {
            const currentCategoryTitle = this.categories.find(x => x.id === id)?.title;
            if (!currentCategoryTitle) {
                return null;
            }

            this.$prompt('Please input your new category name', 'Update this category name', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputValue: currentCategoryTitle,
                inputPattern: /^(?=[\S\s]{1,20}$)[\S\s]*/,
                inputErrorMessage: 'This category name is too long!',
            })
                .then(result => {
                    this.$message({
                        type: 'success',
                        message: 'Your new category name is updated',
                    });

                    this.onUpdateCategoryName(id, result.value);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Canceled to update the new category name',
                    });
                });
        },
        handleDeleteCategory(id) {
            this.$confirm('you cannot see the tasks included in this category.', 'Delete this category?', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: 'Delete completed',
                    });

                    this.onDeleteCategory(id);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled',
                    });
                });
        },
        isSelected(categoryId = '') {
            return categoryId === this.$store.state.todos.selectedCategory;
        },
    },
    props: {
        categories: { type: Array },
        viewType: { type: String },
        selectedDate: { type: String },
        onConfirmDate: { type: Function },
        onViewType: { type: Function },
        onClickTitle: { type: Function },
        onAddCategory: { type: Function },
        onUpdateCategoryName: { type: Function },
        onDeleteCategory: { type: Function },
    },
};
</script>

<style lang="scss" scope>
.vc-calendar {
    width: 100%;
    border-radius: unset;
    border: none;
}

.vc-calendar-key-today {
    border: 2px solid #415de2;
}

.vc-day .vc-opacity-0 {
    opacity: 0.5;
}

.vc-day .vc-pointer-events-none {
    pointer-events: all;
}

.category-wrapper {
    padding: 20px 0 0 0;
    text-align: left;

    .category-title-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;

        .category-header {
            padding-left: 20px;
            margin: 20px 0;
            font-size: 16px;
            font-weight: bold;
        }

        .category-add {
            padding: 10px;
            margin-left: auto;
            cursor: pointer;
            color: #565656;

            &:hover {
                color: #666;
            }
        }
    }

    ul {
        li {
            display: flex;
            padding: 0 10px 0 20px;

            button {
                font-family: 'Inter', 'Nanum Gothic', sans-serif;
                font-size: 0.9rem;
                font-weight: bold;
                text-align: left;
                padding-left: 10px;

                &.category-title {
                    flex-grow: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &.category-option {
                    opacity: 0;
                    margin: 0;
                    padding: 0;
                    color: #6f6f6f;
                    width: 0;
                }
            }

            &.selected {
                background-color: rgba(93, 150, 255, 0.1);

                button {
                    font-weight: bolder;
                }
            }

            &:hover {
                button {
                    color: inherit;
                    opacity: 0.6;
                    font-weight: bolder;
                }

                .iu-button.category-option {
                    opacity: 1;
                    padding: 4px;
                    width: unset;
                }
            }
        }
    }
}
</style>
